import { Button, MessageBar, MessageBarActions, MessageBarBody, MessageBarTitle } from "@fluentui/react-components";
import { Dismiss } from "@ms/planner-generic-controls/lib/local/icons";
import * as React from "react";
import { Strings } from "../../../utilities/CultureUtilities";
/**
 * Informational banner shown when a dynamic AI filter is active on My Tasks.
 */ export const MyTasksStarredMessageBar = ({ isDevice })=>{
    const [isVisible, setIsVisible] = React.useState(true);
    if (!isVisible) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(MessageBar, {
        role: "status",
        intent: "warning"
    }, /*#__PURE__*/ React.createElement(MessageBarBody, null, /*#__PURE__*/ React.createElement(MessageBarTitle, null, isDevice ? Strings.MyTasksPage_StarredDeviceMessageBarTitle : Strings.MyTasksPage_StarredBrowserMessageBarTitle), Strings.MyTasksPage_StarredMessageBarBody), /*#__PURE__*/ React.createElement(MessageBarActions, {
        containerAction: /*#__PURE__*/ React.createElement(Button, {
            appearance: "transparent",
            icon: /*#__PURE__*/ React.createElement(Dismiss, null),
            onClick: ()=>setIsVisible(false),
            "aria-label": Strings.LeftNav_CloseButtonAriaLabel,
            "data-testid": "my-tasks-starred-message-dismiss-button"
        })
    }));
};
